<!--
 * @Description: 
 * @Autor: lwq
 * @Date: 2020-08-10 19:14:39
 * @最后编辑: Betway
 * @最后修改时间: 2021-12-20 15:21:58
 * @FilePath: \mrc-base-frontend\src\views\data-view\modules\index.vue
-->
<template>
  <v-card>
    <v-card-text style="box-sizing: border-box">
      <v-row>
        <v-col cols="12" sm="12">
          <v-checkbox
            :true-value="1"
            :readonly="disabled"
            :false-value="0"
            :disabled="disabled"
            v-model="params.view_status"
            :label="$t('label_View_isActive')"
          ></v-checkbox>
        </v-col>
        <v-col cols="12" sm="6">
          <mrc_ess_multiText
            :label="$t('label_View_name') + '*'"
            :isNational="judegNational('table_name')"
            :readonly="
              this.isHideAdmin && this.$store.state.uuid ? true : disabled
            "
            :error-messages="
              $errors(
                'params',
                'table_name',
                requiredRule.concat([
                  {
                    rule: 'test',
                    msg: $t(
                      'verify_only_input_numbers_underscores_and_English_letters'
                    ),
                  },
                ])
              )
            "
            v-model="params.table_name"
          >
          </mrc_ess_multiText>
        </v-col>
        <!-- judegNational('table_name') -->
        <v-col cols="12" sm="6">
          <mrc_ess_multiText
            :label="$t('label_describe') + '*'"
            style="width: 100%"
            v-model="params.table_description"
            :error-messages="
              $errors('params', 'table_description', requiredRule)
            "
            :isNational="judegNational('table_description')"
            :readonly="disabled"
          >
          </mrc_ess_multiText>
        </v-col>

        <v-col cols="12" v-if="isHideAdmin">
          <mrc_ess_prompt
            :errMsg="$errors('params', 'org_level_uuid', requiredRule)"
            :label="$t('label_The_company') + '*'"
            :disabled="disabled"
            :obj="companyObj"
            v-model="params.org_level_uuid"
          >
          </mrc_ess_prompt>
        </v-col>
        <v-col
          cols="12"
          sm="12"
          class="d-flex flex-column mb-3"
          style="align-items: flex-end"
        >
          <v-sheet width="100%">
            SQL*
            <prism-editor
              :value="params.view_sql"
              :readonly="disabled"
              @change="sqlChangeHandler"
            ></prism-editor>
          </v-sheet>
          <!-- <v-textarea
            :value="params.view_sql"
            style="width: 100%;"
            auto-grow
            @change="sqlChangeHandler"
            :background-color="disabled ? '' : '#f5f5f5'"
            :readonly="disabled"
            :placeholder="disabled ? ' ' : 'SQL'"
            label="SQL*"
          ></v-textarea> -->
          <v-btn
            v-if="sqlChange"
            color="grey darken-2"
            rounded
            class="text-capitalize white--text mt-3"
            depressed
            :loading="ExecuteLoading"
            @click="Execute"
            >{{ $t("label_Executed_immediately") }}</v-btn
          >
        </v-col>
        <v-col cols="12" sm="12">
          <v-card
            v-if="sqlResult"
            style="
              min-height: 200px;
              border: 1px solid #ededed;
              border-radius: 10px;
            "
          >
            <v-card-text>
              <p class="text-h6">{{ $t("label_errorLog") }}</p>
              <p style="text-indent: 2em">{{ sqlResult }}</p>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-card-text>
    <mrc_ess_submitBtn
      @success="success"
      v-if="!disabled"
      :loading="loading"
      @cancel="cancel"
    ></mrc_ess_submitBtn>
  </v-card>
</template>

<script>
import { required } from "vuelidate/lib/validators";
import { delProcedure, runSql } from "@/service/api/dataView";
import PrismEditor from "@/components/PrismEditor.vue";
export default {
  components: { PrismEditor },
  props: {
    paramsProps: {
      type: Object,
      default: () => {},
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      // disabled: false,
      mrbase_sys_datamodel_field: "",
      ExecuteLoading: false,
      params: {
        table_name: "",
        table_description: "",
        view_sql: "",
        view_status: 0,
        para_name: "",
        para_desc: "",
        create_view_sql_status: false,
        org_level_uuid: "",
      },
      sqlResult: "",
      sqlChange: false,
    };
  },
  validations: {
    params: {
      table_name: {
        required,
        test(value) {
          return /^[0-9a-zA-Z_]{1,}$/.test(value);
        },
      },
      table_description: {
        required,
      },
      org_level_uuid: {
        required(val) {
          if (!this.isHideAdmin) {
            return true;
          } else {
            if (val) {
              return true;
            }
            return false;
          }
        },
      },
    },
  },
  computed: {
    companyObj() {
      return {
        prompt_name: "org_levels_manager_filter_company_company",
        user_id: this.$store.state.userData.user_id,
        org_level_code: this.$store.state.currentCompanyObj.org_level_code,
      };
    },
    isHideAdmin() {
      return this.$store.state.userData.userType == 3;
    },
  },
  created() {},
  watch: {
    paramsProps: {
      handler(val) {
        this.params = Object.assign({}, this.params, val);
      },
      deep: true,
    },
    // 'params.view_sql' (val, oldVal) {
    //   if (oldVal!= val && val) {
    //     this.sqlChange = true
    //   }
    // }
  },
  async created() {
    await this.national("mrbase_sys_datamodel_field");
    if (this.paramsProps) {
      this.params = Object.assign({}, this.params, this.paramsProps);
      this.sqlChange = false;
    }
  },

  methods: {
    sqlChangeHandler(val) {
      if (val == this.params.view_sql) {
        this.sqlChange = false;
      } else {
        this.params.view_sql = val;
        this.sqlChange = true;
        // await this.Execute()
      }
    },
    cancel() {
      if (this.$store.state.uuid) {
        this.$emit("changeReadonly");
      } else {
        this.$router.go(-1);
      }
      // this.$myConfirm({
      //   content: this.$t("message_Confirm_the_cancellation_of_the_edit"),
      // })
      //   .then(() => {
      //     if (this.$store.state.uuid) {
      //       this.$emit("changeReadonly")
      //     }
      //     else {
      //       this.$router.go(-1)
      //     }
      //   })
      //   .catch(() => { })
    },
    success() {
      if (this.params.view_sql) {
        if (this.sqlChange) {
          let tips = this.$t("message_sql_statement_execution_error");
          if (this.sqlResult) {
            tips = this.$t("message_sql_statement_execution_error");
          } else {
            tips = this.$t("message_sql_statement_has_been_changed");
          }
          this.$myConfirm({ content: tips })
            .catch(() => {})
            .then(() => {});
          return;
        }
      } else {
        this.$myConfirm({
          content: this.$t("message_please_enter_the_sql_statement"),
        })
          .then(() => {})
          .catch(() => {});
        return;
      }
      this.$v.params.$touch();
      if (this.$v.params.$error) return;
      this.$emit("success", this.params, this.mrbase_sys_datamodel_field);
    },
    async Execute() {
      if (this.params.view_sql) {
        this.ExecuteLoading = true;
        try {
          const res = await runSql({
            view_sql: this.params.view_sql,
            view_status: this.params.view_status,
            table_type: this.params.table_type,
          });
          if (res.code == 200) {
            this.mrbase_sys_datamodel_field = res.data;
            this.sqlChange = false;
            this.sqlResult = "";
            this.params.create_view_sql_status = true;
          } else {
            this.sqlResult = res.msg;
          }
          this.ExecuteLoading = false;
        } catch (err) {
          this.ExecuteLoading = false;
        }
      } else {
        this.$myConfirm({
          content: this.$t("message_please_enter_the_sql_statement"),
        })
          .then(() => {})
          .catch(() => {});
      }
    },
  },
};
</script>

<style scoped></style>
